export interface ProductionOrderQuery {
  type?: number;
  status?: string;
  companyId?: string;
}

export interface ProductionOrderItemViewModel {
  id?: string;
  order?: number;
  ncm?: string;
  quantity?: string;
  product?: string;
  unitValue?: string;
  productionOrderId?: string;
}

export interface ProductionOrderViewModel {
  id?: string;
  createdDate?: string;
  updatedDate?: string;
  processId?: string;
  processCvfRef?: string;
  containerQuantity?: string;
  origin?: string;
  brand?: string;
  factory?: string;
  category?: string;
  /** Prontidão informada à mão (sobrepõe a estimada). */
  expectedReadinessDate?: string;
  /** Início da produção + tempo de produção do fornecedor. */
  estimatedReadinessDate?: string;
  processOpeningDate?: string;
  /** Manual, senão entrada do processo em "MERCADORIA EM PRODUÇÃO". */
  productionStartDate?: string;
  productionStartIsManual?: boolean;
  supplierName?: string;
  supplierProductionDays?: number;
  documentPath?: string;
  status?: string;
  type?: number;
  items: ProductionOrderItemViewModel[];
}

export interface ProductionOrderItemCommand {
  order?: number;
  ncm?: string;
  quantity?: string;
  product?: string;
  unitValue?: string;
}

export interface ProductionOrderCommand {
  id?: string;
  containerQuantity?: string;
  origin?: string;
  brand?: string;
  factory?: string;
  category?: string;
  expectedReadinessDate?: string;
  status?: string;
  type?: number;
}

export const productionOrderStatuses = ["EM PRODUÇÃO", "PRONTO", "EMBARCADO"];
